export interface Environment {
    stage: Stage
    api: {
        schema: 'http' | 'https'
        host: string
        graphqlPath: string
    }
    pusher: {
        app_id: string
        key: string
        secret: string
        cluster: string
    }
}

export enum Stage {
    Test = 'test',
    Acc = 'acc',
    Prod = 'prod',
}
